/** @jsxImportSource minimal-view */

import { element, view, web } from 'minimal-view'
import themes from 'plenty-themes/_all.json'
import { classes } from './util/classes'
import { skin } from './skin'
import { hmr } from './hmr'

const keys = [
  'black',
  'red',
  'green',
  'yellow',
  'blue',
  'purple',
  'cyan',
  'white',
  'brightBlack',
  'brightRed',
  'brightGreen',
  'brightYellow',
  'brightBlue',
  'brightPurple',
  'brightCyan',
  'brightWhite',
  'foreground',
  'background',
  'cursorColor',
]

export const ThemePicker = hmr(web(view('theme-picker',
  class props {
  },
  class local {
    host = element
    active = false
  },
  function actions({ $, fn, fns }) {
    return fns(new class actions {
    })
  },
  function effects({ $, fx, deps, refs }) {
    $.css = /*css*/`
    & {}

    button {
      all: unset;
    }

    .toggle {
      height: 8px;
      display: inline-flex;
      position: fixed;
      right: 0;
      bottom: 0;
      z-index: 999;
    }

    .themes {
      position: fixed;
      left: auto;
      top: 0;
      right: 35px;
      bottom: 0;
      overflow-y: scroll;
      max-width: 500px;
      z-index: 9999;
    }

    .theme {
      width: 50px;
      padding: 5px;
      display: inline-flex;
      flex-flow: row wrap;
      &.selected,
      &:hover {
        background: #fff3;
      }
    }

    .color {
      width: 8px;
      height: 8px;
      display: inline-flex;
    }
    `

    fx(({ active }) => {
      $.view = <>
        <button class="toggle" onclick={() => {
          $.active = !$.active
        }}>
          <div class="color" style="background:#f0f" />
          <div class="color" style="background:#ff0" />
          <div class="color" style="background:#0ff" />
        </button>

        {active && <div class="themes">{
          themes.map((theme) => <button class={classes({
            theme: true,
            selected: JSON.stringify(skin.$.theme) === JSON.stringify(theme)
          })} onclick={() => {
            skin.$.theme = theme
          }}>
            {keys.map((key) =>
              <div class="color" style={`background:${(theme as any)[key]}`} />
            )}
          </button>)
        }</div>}
      </>
    })
  }
)))
